/*
 * @Author: Merlin
 * @Date: 2024-03-11 14:16:26
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-14 17:12:50
 * @Description: ;
 */
import scroll from '@/assets/mp3/pharaoh/scroll.mp3';
import scroll2 from '@/assets/mp3/pharaoh/scroll2.mp3';
import scroll_set1 from '@/assets/mp3/pharaoh/scroll_set1.mp3';
// ↑ scroll 系列 ◆ 
import line_sound1 from '@/assets/mp3/pharaoh/line_sound1.mp3';
import line_sound2 from '@/assets/mp3/pharaoh/line_sound2.mp3';
import music_start from '@/assets/mp3/pharaoh/music_start.mp3';
import background from '@/assets/mp3/pharaoh/music_loop.mp3';
// --- ↓ bonus_game_ 系列 --------------------------------------------------- 
import bonus_game_start from '@/assets/mp3/pharaoh/bonus_game_start.mp3';
import bonus_game_riseFX from '@/assets/mp3/pharaoh/bonus_game_riseFX.mp3';
import bonus_game_background from '@/assets/mp3/pharaoh/bonus_game_background.mp3';
import bonus_game_scroll from '@/assets/mp3/pharaoh/bonus_game_scroll.mp3';
import bonus_game_vild_1 from '@/assets/mp3/pharaoh/bonus_game_vild_1.mp3';
import bonus_game_vild_2 from '@/assets/mp3/pharaoh/bonus_game_vild_2.mp3';
import bonus_game_vild_3 from '@/assets/mp3/pharaoh/bonus_game_vild_3.mp3';
// ↑ 音效 ----------------------------------------------------- 
import sBigPic from "../img/atlas.png";
import {usePharaohSocket} from '@/socket/game/pharaoh.ts';
import {betableCheck, showTips4BadAmountIfNeeded} from '@/common/js/betHelper';
import {Wi} from './pharaoh-anim-01';
import {ki} from './pharaoh-anim-02';
import { useCryptosImages } from '~/utils/fileImport'; // 币种图片全集 
const { EMIT_PHARAOH_BET, } = usePharaohSocket();

// res.roll_number = 'H1,H2,H3,H4 ◆ B ◆ N1,N2,N3,N4'; // 🎀 ←对照关系表 
// res.roll_number = '塔,虫,猫,A  ◆ B ◆  K,Q,J,10';


// ↓ 币种图 
const oCoinImg = (()=>{
    if (!import.meta.client) return;
    const oAllPic = useCryptosImages();
    const oResult = {};
    Object.keys(oAllPic).forEach(sKey => {
        const oPic = Object.assign(new Image, {
            src: oAllPic[sKey],
            width: 25,
            height: 25,
        });
        oResult[sKey] = oPic;
    });
    return oResult;
})();


// ↓ 5个中奖形式 
const aFivePrize = Object.freeze({
    top: [0, 3, 6],
    mid: [1, 4, 7],
    bot: [2, 5, 8],
    Dtop: [0, 4, 8],
    Dbot: [2, 4, 6],
});

// ↓ 高度值
export const aHeightArr = [507, 416];

// ↓ 由用户点击触发的方法 =================================================================
const oUserAction = {
    toChangeMode(isAuto){
        this.isAutoMode = !!isAuto;
        if (isAuto){
            this.oAutoDialog.switchAutoDialogVisible(true);
        }
    },
    // ↓点击🟦蓝色按钮，弹出确认购买窗口 
    clickBlueButton(){
        if (!betableCheck(this.oForm)) return;
        this.sCenterDialog = 'buying';
        // console.log('购买窗口已经打开');
        const {amount=0} = this.oForm;
        const multi = 999; // 理论上的最大赔付倍数 
        showTips4BadAmountIfNeeded(amount * multi);
    },
    // ↓关闭中间窗口（放弃买特奖） 
    closeCenterDialog(){
        this.sCenterDialog = '';
    },
    // ↓ 买特奖（确认购买），旋转主画布， 然后打开摇奖窗口 
    async toBuy(){
        // 点击购买之后应立即禁用“整个” 下注面板
        const res = await this.toEmitBet({
            buyBonus: true,
        });
        if (!res || res.error) {
            showNegativeNotify(res?.error);
            return;
        }
        this.rollingOnBigCanvas = true;
        this.oResult.showAmount = false;
        this.oResult.winAmount = 0;
        Object.assign(this, {
            sCenterDialog: '', // 关闭确认窗口
            scaleFire: 0.1,
            scaleBonus: 1,
        });
        await this.$nextTick(); // 等窗口彻底关闭 
        await this.spinToBonus(); // 🧧 主画布开始旋转，转出 bonus
        this.rollingStarted = false;
        this.rollingOnBigCanvas = false;
        this.startShowBonusGame();
    },
    
    // ↓ 开始 BonusGame 
    // ↓ 购买特奖后将弹出，或摇奖后也可能弹出 
    async startShowBonusGame(usReloading){
        this.sCenterDialog = 'rolling'; // 打开 bonus 摇奖窗口 
        await this.$nextTick(); // 等 canvas dom 插入
        await Sleep(100);
        console.log("打开了 bonus 摇奖窗口 ");
        const {g_instance, m_instance, $refs} = this; 
        g_instance.init(
            $refs.canvasBonus,
            this.oMusicControler.oAudio,
        );
        g_instance.redraw(g_instance.ctx);
        // ↓ 使主画布内容消失（特奖的放射动画结束后再恢复） 
        m_instance.setGameMode("BonusGame");
        try{
            let oAudio = this.oMusicControler.oAudio;
            oAudio?.music_start?.stop(); 
            await scheduler.yield();
            oAudio?.music_start?.unload(); 
            await scheduler.yield();
            oAudio.background.stop();
            await scheduler.yield();
            if (usReloading === true){
                // 此致表示正在刷新后重载的游戏，变更默认的 bgm  
                this.setSoundPlan();
                oAudio = this.oMusicControler.oAudio; 
            }
            oAudio.bonus_game_background.toPlay();
            await scheduler.yield();
            oAudio.bonus_game_start.toPlay();
        }catch (err){
            console.log('music error', err); 
        }
    },
    // ↓ 🖱️ 点击【摇奖】按钮，驱动小画布旋转  
    // ↓ 有可能是购买了特奖，也有可能是在主画布摇到了特奖 
    async onBonusGame() {
        const {oMusicControler: {oAudio}, isAutoMode} = this;
        oAudio.bonus_game_scroll.stop();
        oAudio.bonus_game_scroll.toPlay();
        const ts = this.oUserStore.queueStart(); // 阻止余额立即变化
        const res = await this.toEmitBet({
            isBonusBet: true,
        });
        if (!res || res.error) { 
            return this.oBonusRolling.resolve(res); // reject
        }
        this.rollingStarted = true;
        Object.assign(this.oResult, res);
        // ↓ 旋转转到目标位置， 
        await this.scroll2BonousResult(res);
        this.sCenterDialog = '';
        await Sleep(200);
        this.oJoinStateStore.showDateInQueue(); // 插入游戏结果并播放动画
        this.oUserStore.queueForward(ts); 
        if(!this.isAutoMode){
            this.oJoinStateStore.gameRunning = false; 
        }
        // ↓没摇到奖， 
        if (res.roll_number === '000') {
            this.sCenterDialog = 'rollingResult-lose'; // 打开结果窗口
        }else{
            this.sCenterDialog = 'rollingResult-win'; // 打开结果窗口
            this.oResult.showAmount = true;
            this.m_instance.coinsExpl.init(); // 播放烟花特效 
            this.iAmountLastWin = res.winAmount;
        }
        const iDelay = 2_000;
        // ↓关闭摇奖窗口，恢复音乐，恢复主画布 
        this.iClosePlan = setTimeout(this.endShowBonusGame, iDelay);
        await Sleep(iDelay);
        // ↓ 因为原生的幂等性，可以调用，但只在自动模式有实际作用  
        this.oBonusRolling.resolve({
            amount: 0,
            winAmount: res.winAmount,
        });
    },
    // ↓ 仅用于：播放小画布摇奖动画
    async scroll2BonousResult(res){
        const {g_instance, oMusicControler: {oAudio}} = this;
        fnCanvasAnimationRunner(g_instance); // ← 运行动画
        var {oPromise, resolve, reject} = createPromise();
        g_instance.showAnim({
            res: res.roll_number,
            endSpin2: () => {
                oAudio.bonus_game_riseFX.stop();
                oAudio.bonus_game_riseFX.toPlay();
            },
            endSpin1: ()=>{
                this.scaleBonus = 1.08;
                g_instance.showLightAnimation();
            },
            endSpin0: ()=>{
                this.scaleBonus = 1;
                g_instance.hideLightAnimation();
            },
            onEndAnimation: resolve,
        });
        await oPromise;
        g_instance.live = false;
        this.scaleFire = 1; // 放大火焰图案 
        await Sleep(1_800);
    },
    // ↓ 在弹窗中摇奖结束后要恢复音乐，而且要重绘主画布 
    endShowBonusGame(){
        clearTimeout(this.iClosePlan);
        const toClose = this.sCenterDialog.startsWith('rollingResult-');
        if (toClose){
            this.sCenterDialog = '';
        }
        this.rollingStarted = false;
        this.rollingOnBigCanvas = false;
        const {oAudio} = this.oMusicControler;
        oAudio.bonus_game_background.stop();
        oAudio.background.toPlay();
        this.m_instance.randomStart(); // 重绘主画布 
    },
    // ↓ 摇奖 
    toSpin(){

    },
    // ↓🖱️ 点击下注，分发任务：手动|自动
    clickOnBetButton01(){
        if (!this.isAutoMode) {
            return this.onBtnClick();;
        }
        // ↑手动
        // ↓自动
        if (this.oForm.isSubmiting) {
            // 摇奖窗口弹出时， 可立即关闭 
            if (1){
                return this.stopInfinity();
            } else {
                // 添加关闭计划？？？
                return this.stopInfinity();
            }
        }
        return this.startInfinity();
    },
    // ↓ 用于自动下注方法包使用的函数，内部按情形执行不同的方法
    async fnForAutoBetTool(){ 
        let oRes = {};
        const {pending, oPromise} = this.oBonusRolling;
        // ↓ 刚中了特奖，取得 bonus 摇奖结果  
        if (pending){
            this.oBonusRolling.pending = false;
            oRes = await oPromise; 
        }else{ // ← 普通情况
            oRes = await this.onBtnClick();
        }
        if (!oRes || oRes.error){
            return oRes;
        }
        const oResult = {
            amount: oRes.amount,
            winAmount: oRes.winAmount,
        };
        return oResult;
    },
    // ↓ 🟥红色按钮的函数（开始摇奖） 
    async onBtnClick(){
        if (!betableCheck(this.oForm)) return;
        this.closeCenterDialog();
        this.oResult.winAmount = 0;
        this.oResult.showAmount = false;
        this.rollingStarted = false; 
        const ts = this.oUserStore.queueStart(); // 阻止余额立即变化
        const res = await this.toEmitBet();
        if (!res || res.error) {
            this.oUserStore.queueDelete(ts); 
            return res;
        }
        this.rollingOnBigCanvas = true;
        const oBetResult = {
            amount: this.oForm.amount,
            winAmount: res.winAmount,
        };
        // res.roll_number = 'H1,H2,H3,H4,B,N1,N2,N3,N4';
        // res.roll_number = '塔虫猫A ◆ B ◆ K,Q,J,10';
        Object.assign(this.oResult, res);
        const endResult = this.swapResult(res.roll_number, true);
        var {oPromise, resolve, reject} = createPromise();
        printResult(res, endResult); // 调试打印
        this.m_instance.moveTo({
            endResult,
            onEndMove: resolve,
            isFast: this.isFast,
        });
        await oPromise;
        this.oUserStore.queueForward(ts);
        let hasWon = res.winAmount > 0 || res.bonusWin;
        if (res.winAmount > 0){
            this.iAmountLastWin = res.winAmount;
        }
        const winResult = this.getWinResult(res);
        if (import.meta.dev){
            const aReformed = winResult?.[0] || [];
            console.log("中奖判定 1：", deepCopy(aReformed)); 
            hasWon = aReformed?.[2]?.length > 0;
        }
        this.oJoinStateStore.showDateInQueue(); // 插入游戏结果并播放动画
        if (!hasWon) {
            if (this.isAutoMode) await Sleep(500); // 画布逗留一会儿 
            this.rollingOnBigCanvas = false;
            this.oJoinStateStore.gameRunning = false; 
            return oBetResult; // 没赢钱就返回 
        }
        if (!res.bonusWin){
            // ↓ 没摇中 bonus 时要及时解锁按钮，使用户能立即开始下一局游戏  
            this.rollingOnBigCanvas = false;
        }
        console.log("== 已经中奖，即将闪烁中奖结果：============"); 
        winResult.forEach(cur => {
            console.log(JSON.stringify(cur));
        });
        await this.afterWin(res, winResult);
        console.log("res.bonusWin =>", res.bonusWin);
        if (res.bonusWin){
            if (this.isAutoMode){
                this.oBonusRolling = createPromise();
                // ↓添加标识，表示在自动模式摇到了特奖，下一步需要摇特奖 
                this.oBonusRolling.pending = true;
            }
            // ↓ 打开摇奖窗口 
            await this.startShowBonusGame();
        }else if(!this.isAutoMode){
            this.oJoinStateStore.gameRunning = false; 
        }
        return oBetResult;
    },
    // == ↓ 主画布动画：中奖专用动画效果 ===========================
    async afterWin(res, winResult){
        var {oPromise, resolve, reject} = createPromise();
        // const {locale} = useNuxtApp().$i18n;
        const {currencyName} = this.oUserStore.oNowCurrency;
        this.m_instance.startShowWin({
            winResult,
            onEndShowWin: resolve,
            isFast: this.isFast,
            img: oCoinImg[currencyName], // 币种的图形对象
            fiatCurrency: '', // currencyName, // 接收法币名称，如 USD, CNY，虚拟货币将报错 
            inFiat: true, 
            locale: "en",
        });
        await oPromise;
        this.oResult.showAmount = true;
        console.log(`一闪完成： animation, isFast =\n`, this.animation, this.isFast);
        if (!this.animation || this.isAutoMode) {
            // ↓ 用户关闭动画时要制止无限闪烁 
            const reformed = this.swapResult(res.roll_number, false);
            this.m_instance.setGameMode("Stay", reformed); 
            const iMS = res.bonusWin ? 200 : 500;
            await Sleep(iMS); // ← 停留一小会
        }
    },
};

// ↓ 打印请求结果等（用于调试） 
function printResult(res, arr2){
    if (!import.meta.dev) return;
    console.log("01-下注返回：\n", deepCopy(res)); 
    const arr = res.roll_number.split(',');
    const sResult = [
        '\n', arr[0], arr[3], arr[6],
        '\n', arr[1], arr[4], arr[7],
        '\n', arr[2], arr[5], arr[8],
    ].join(' ').trim();
    console.log('原始值-同画布布局：\n', sResult);
    // console.log('解析值-用于旋转：\n', arr2[0].join(' '), '\n', arr2[1].join(' '), '\n', arr2[1].join(' '));
}


// ↓ 外来方法 =====================================================================
const oFnExtra = {
    // ↓ 将请求结果转换数据形态，用于旋转 
    // ↓ 一参示例："N1,N1,H4,N1,N1,H2,H3,H3,N3"
    swapResult(n, bMark) {
        let t = n.split(","); // ← 关键数组，也是最后返回值 
        const oLetterNumberMap = {
            H1: 0,
            H2: 1,
            H3: 2,
            H4: 3,
            N1: 4,
            N2: 5,
            N3: 6,
            N4: 7,
            B: 8, // bonus
        };
        t = t.map(cur => oLetterNumberMap[cur]); // 字符转数字
        t = [
            [t[0], t[1], t[2]],
            [t[3], t[4], t[5]],
            [t[6], t[7], t[8]],
        ];
        if (bMark) { // 摇奖时为 true 
            t.forEach(s => s.unshift(0));
        } else { // 摇奖后显示结果时为 false 
            t.forEach(s => s.push(0));
        }
        return t;
    },
    // ↓ 参数是请求结果对象 
    // ↓ 参数的成员被调用统计： roll_number, bonusWin, winAmount 
    getWinResult(oParams) {
        // ↓ 最终 return 此值; 数据结构： [['Dbot', 400, Array(1)], [], [], []]
        let aResult = [];  // ←位于 [0][1] 的值是主画布的动态数字值 
        let {amount} = this.oForm;
        // if (import.meta.dev) amount ||= 10; // 需要删除  
        const aLines = [];
        const a01 = oParams.roll_number.split(",");
        const {coefs} = this.oJoinStateStore.config;
        for (const sPrizeName in aFivePrize) {
            const aCur = aFivePrize[sPrizeName];
            const h = a01[aCur[0]];
            const l = a01[aCur[1]];
            const f = a01[aCur[2]];
            const hasWon = h === l && h === f && h !== "B";
            if (!hasWon) continue; // ←
            const iValueWon = amount * coefs[h];
            // ↓ 'mid', 0, ['mid']
            aResult.push([sPrizeName, iValueWon, [sPrizeName]]);
            aLines.push(sPrizeName);
        }
        console.log("aResult 初步值：", deepCopy(aResult)); 
        console.log("this.isFast", this.isFast); 
        /*
            至此，如果没启动 fast 模式 && !oParams.bonusWin 则 aResult 已经定型
            此时 aResult 形态记录：[
                ["mid", 0, ["mid"]],
                ["Dbot", 0, ["Dbot"]],
            ]
            aLines 形态：["mid", "Dbot"]
        */
        if (this.isFast) { 
            oParams.bonusWin && aLines.push("bonus");
            // ↓ 覆盖了 😧 确实覆盖了。推断可使多区同时闪烁 
            aResult = [[
                aLines.length === 1 ? aLines[0] : "mid", // ← mid 意在只在中部闪烁  
                oParams.winAmount, // ←赢钱总额 
                aLines,
            ]];
        } else if (oParams.bonusWin) {
            aResult.push(["bonus", 0, [""]]);
            // this.bonusGameCurrency = this.currentCurrency; // 原版币种赋值 
        }
        // 4倍：此时 aResult 形态：[["mid", 0, ["mid", "Dbot"]]]
        // 12倍形态，X型与一型相同 ：[["mid", 0, ["mid", "Dtop", "Dbot"]]]
        return aResult;
    },
};


// ↓ 被动方法  ============================================================================================
const oPassiveFn = {
    async toEmitBet(oData={}){
        this.oJoinStateStore.gameRunning = true; 
        const oParams = {
            amount: this.oForm.amount, // 即便购买特奖花 800, 也只需要提交基数值 10 
            frontID: Date.now(),
            isFast: this.isFast,
            // buyBonus: boolean, // 为 true 表示用户正在购买特奖
            // isBonusBet: boolean, // 为 true 表示在小窗口摇奖（特奖） 
            ...oData, // ←内含2个： buyBonus, isBonusBet
        };
        // if (import.meta.env.DEV_MODE && Math.random() <= 0.3 && this.isAutoMode){  
        //     oParams.amount = '0'; 
        // }
        const res = await EMIT_PHARAOH_BET(oParams);
        if (import.meta.dev){
            console.log("提交与返回数据：");
            console.log(deepCopy(oParams));
            console.log(deepCopy(res));
        }
        if (!res || res.error){
            if (!this.isAutoMode){
                showNegativeNotify(res?.error); 
            }
            this.oJoinStateStore.gameRunning = false; 
        }
        return res;
    },
    // ↓ 大画布转到特奖（bonus）结果 
    async spinToBonus(){
        const getNum = (o, a)=>{ // 取得随机数
            return Math.floor(Math.random() * (a - o) + o);
        };
        let ss = ["H", "N", "H", "N", "B", "N", "H", "N", "H"];
        ss[getNum(0, 3)] = "B";
        ss[getNum(6, 9)] = "B";
        ss = ss.map(o => {
            return o === "B" ? o : o + getNum(1, 5);
        });
        var {oPromise, resolve, reject} = createPromise();
        // this.modalVisible = false;
        this.m_instance.moveTo({
            endResult: this.swapResult(ss.join(","), true),
            onEndMove: resolve,
            isFast: this.isFast,
        });
        await oPromise;
        var {oPromise, resolve, reject} = createPromise();
        // ↓ 触发闪烁 
        this.m_instance.startShowWin({
            winResult: [["bonus", 0, [""]]],
            onEndShowWin: resolve,
            isFast: this.isFast,
        });
        await oPromise;
    },
    // ↓ 动画类的初始化方法 
    async startTheAnim(){
        const {slotCanvas, oBigPic} = this.$refs;
        if (!slotCanvas || !oBigPic) {
            return console.error('注意，必要元素未加载'); // 从未打印 
        }
        // console.log('atlas complete ? ', oBigPic.complete); // 只有见到结果为 true 
        const {oPromise, resolve, reject} = createPromise();
        if (oBigPic.complete) resolve();
        else oBigPic.addEventListener('load', resolve); 
        await oPromise;
        // ↓ 大画布, m is main 
        const m_instance = Object.assign(new Wi(), {
            animation: this.animation,
        });
        // ↓ 摇奖（特奖）动画 
        const g_instance = Object.assign(new ki(), {
            atlas: oBigPic,
            animation: this.animation,
        });
        Object.assign(this, {
            g_instance,
            m_instance,
        });
        m_instance.init([
            slotCanvas,
            oBigPic,
            this.canvasSizeIndex,
            this.oMusicControler.oAudio,
            ii => this.scale = ii,
        ]);
        fnCanvasAnimationRunner(m_instance); 
        // ↓宣告画布的动画实例已经创建完成  
        this.oCanvasInstanceStatus.resolve(); 
        return true; // 动画实例创建完成
    },
    // ↓ 加载音乐信息 
    musicLoader(type=1){
        if (!import.meta.client) return; 
        // isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
        const oMusicLib = {
            scroll: {src: scroll, },
            scroll2: {src: scroll2, },
            scroll_set1: {src: scroll_set1, },
            line_sound1: {src: line_sound1, },
            line_sound2: {src: line_sound2, },
            music_start: { // BGM-1-在开始时播放，
                src: music_start,
                isBGM: true,
                volumeFrom: 'music',
                onend: () => this.setSoundPlan(),
            }, 
            background: {src: background, isBGM: false, volumeFrom: 'music', loop: true }, // 将被重载（被覆盖）
            // ↓ bonus_game_ 系列 ----------
            bonus_game_start: {src: bonus_game_start, },
            bonus_game_riseFX: {src: bonus_game_riseFX, },
            bonus_game_background: {src: bonus_game_background, volumeFrom: 'music', loop: true }, // 小窗口摇奖时播放 
            bonus_game_scroll: {src: bonus_game_scroll, },
            bonus_game_vild_1: {src: bonus_game_vild_1, },
            bonus_game_vild_2: {src: bonus_game_vild_2, },
            bonus_game_vild_3: {src: bonus_game_vild_3, },
        };
        if (type === 2){
            console.log('BGM-2 开始加载！');
            Object.assign(oMusicLib.music_start, {
                loop: false,
                isBGM: false, 
                onend: ()=>null,
            });
            Object.assign(oMusicLib.background, {
                loop: true,
                isBGM: true,
            });
        }
        const oMusicControler = new MusicControler(oMusicLib);
        return oMusicControler;
    },
    // ↓ 首次播放音乐 
    setSoundPlan(){
        // console.log('入场音乐播放完毕，或因加载上局游戏而终止');
        this.oMusicControler?.toDestory();
        Object.assign(
            this.oMusicControler,
            this.musicLoader(2),
        );
    },
    // ↓ 
    setCanvas(){
        const idx = window.innerWidth > 500 ? 0 : 1;
        if (idx === this.canvasSizeIndex) return;
        const {$refs, m_instance} = this;
        if (!$refs.slotCanvas || !m_instance) {
            console.error('元素缺失，注意');
            console.error('$refs.slotCanvas', $refs.slotCanvas);
            console.error('m_instance', m_instance);
            return;
        }
        this.canvasSizeIndex = idx;
        $refs.slotCanvas.width = [2088, 1000][idx];
        $refs.slotCanvas.height = [1149, 1178][idx];
        m_instance.resize(idx);
    },
    // ↓ 设定高度
    setDomHeight(){
        const idx = window.innerWidth > 420 ? 0 : 1;
        const iNewHeight = aHeightArr[idx];
        // console.log("iNewHeight =", iNewHeight); 
        this.iStageHeight = iNewHeight;
    },
};


export const oMethods = {
    ...oPassiveFn,
    ...oUserAction,
    ...oFnExtra,
};




// ↓购买特奖后返回的历史信息 
var aa = {
    "amount": 987.2,
    "confirmed": false,
    "currency": "",
    "timestamp": "2024-04-11T07:10:49.000Z",
    "user": "6566c714572c629a6d05e562",
    "isBonusGame": true,
    "hash": "703c00e7b19f5ad05e8e86de5860db435d73165147692aaad261ae3abcc17955",
    "bonusGameAmount": 12.34,
    "userInfo": {
        "isSystemAccount": false,
        "type": "default"
    },
    "isBuyBonus": true,
    "_id": "66178cf90d5f34acae6814e6"
}

// ↓ 页面刷新之后的历史数据 
var aa = {
    "_id": "66178cf90d5f34acae6814e6",
    "amount": 987.2,
    "currency": "",
    "timestamp": "2024-04-11T07:10:49.000Z",
    "user": "6566c714572c629a6d05e562",
    "isBonusGame": true,
    "hash": "703c00e7b19f5ad05e8e86de5860db435d73165147692aaad261ae3abcc17955",
    "bonusGameAmount": 12.34,
    "userInfo": {
        "isSystemAccount": false,
        "type": "default"
    },
    "isBuyBonus": true,
    "multi": 33,
    "randomSeed": "033_ZOlFHptTGTnVBY",
    "winAmount": 407.22,
    "bonusWinAmount": 0
}



// 返回值如下：
var bbb = { 
    "_id": "66178e5c0d5f34acae6817fe",
    "amount": 880.96,
    "currency": "",
    "timestamp": "2024-04-11T07:16:44.503Z",
    "user": {
        "_id": "6566c714572c629a6d05e562",
        "avatar": 0,
        "lvl": 1,
        "name": "User6976774"
    },
    "isBonusGame": true,
    "hash": "0f7c847cfa4ddbd7ad6c390cf3df9e70eda9bad18dd078d738b6721773a21aa5",
    "bonusGameAmount": 11.012,
    "userInfo": {
        "isSystemAccount": false,
        "type": "default"
    },
    "isBuyBonus": true,
    "balanceBefore": 5548.03,
    "multi": 143,
    "randomSeed": "143_WPCxHqZRLhLKJV",
    "winAmount": 1574.716,
    "roll_number": "143",
    "game": {
        "id": "6499a71d6f96f997cb13bdb4"
    }
}